export { cn, cn as classNames } from "@/lib/utils";
